/* eslint-disable no-unused-vars */
import React from 'react';
import reduce from 'lodash-es/reduce';
import keys from 'lodash-es/keys';
import map from 'lodash-es/map';
import size from 'lodash-es/size';
import findIndex from 'lodash-es/findIndex';
import { CSSTransition } from 'react-transition-group';

// Не костыль, а фича против фичи автоматической сортировки числовых полей объектов js
type AvailableValues = ' 1' | ' 2' | ' 3' | ' 4' | ' 5' | ' 6';
const allAvailableValues: AvailableValues[] = [
  ' 1',
  ' 2',
  ' 3',
  ' 4',
  ' 5',
  ' 6',
];

type DefaultMesh = { [key in AvailableValues]?: number };

export const getMeshKey = (val: number) => {
  const index = findIndex(allAvailableValues, (av) => av === ` ${val}`);

  if (index === -1) {
    return allAvailableValues.slice(-1)[0];
  }

  return allAvailableValues[index];
};

export type RowSizes = {
  w: number;
  h: number;
};

export type UseGridProps<T_MESH, T_ITEM> = {
  // Сетке можно задавать циклический узор, ключ - количество столбцов в строке, значение - высота строки
  mesh: T_MESH;
  items: T_ITEM[];
  constructItem: (item: T_ITEM) => React.ReactNode;
  containerWidth: number;
  gap: number;
  duration: number;
  shouldImagesScroll?: boolean;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export function useGrid<
  T_MESH extends DefaultMesh,
  T_ITEM extends { id: string }
>({
  mesh,
  containerWidth,
  gap,
  items,
  constructItem,
  duration,
  shouldImagesScroll,
  ...containerProps
}: UseGridProps<T_MESH, T_ITEM>) {
  type MeshKeys = keyof typeof mesh;
  // const windowSize = useWindowSize();

  // Ключом является количество столбцов в строке,
  // Значение - размеры элемента в этой строке:
  // Высота - задается в параметрах mesh
  // Ширина - Считается из размеров контейнера
  const sizes = reduce(
    mesh,
    (acc: { [key in MeshKeys]?: RowSizes }, val, key) => {
      const mk = key as MeshKeys;
      const cols = Number(mk);

      const h = Number(mesh[mk]);
      const w = (containerWidth - gap * (cols - 1)) / cols;

      acc[mk] = {
        w,
        h,
      };
      return acc;
    },
    {}
  );

  // Возвращает количество столбцов в строке под номером row
  const getRowCapacity = (row: number) => {
    const meshKeys = keys(mesh);
    const meshRow = (row - 1) % meshKeys.length;

    return meshKeys[meshRow] as MeshKeys;
  };

  let row = 1;
  let col = 0;
  let capacity = getRowCapacity(row);
  let topOffset = 0;
  let conteinerHeight = 0;

  const readyItems = map(items, (item, i) => {
    col += 1;

    if (col > Number(capacity)) {
      // Высота в линии сетки перед сменой на следующую
      const currrentH = sizes[capacity]?.h || 0;
      topOffset += currrentH + gap;

      conteinerHeight = topOffset;

      col = 1;
      row += 1;
      capacity = getRowCapacity(row);
    }

    // Для последнего ряда
    if (i === size(items) - 1) {
      const currrentH = sizes[capacity]?.h || 0;
      conteinerHeight = topOffset + currrentH + gap;
    }

    // Высота и ширина элемента в текущей линии сетки
    const currrentW = sizes[capacity]?.w || 0;
    const currrentH = sizes[capacity]?.h || 0;

    const leftOffset = (col - 1) * currrentW + (col - 1) * gap;

    return (
      <CSSTransition
        timeout={duration}
        classNames="gridListItem-tg"
        key={item.id}
      >
        <div
          {...containerProps}
          style={
            !shouldImagesScroll
              ? {
                  position: 'absolute',
                  width: `${currrentW}px`,
                  height: `${currrentH}px`,
                  transform: `translate(${leftOffset}px, ${topOffset}px)`,
                  transition: `transform ${duration}ms ease-in`,
                }
              : {
                  position: 'relative',
                  width: '260px',
                  height: '250px',
                  transform: `translate($0px, $0px)`,
                  transition: `transform ${duration}ms ease-in`,
                  flexShrink: 0,
                }
          }
        >
          {constructItem(item)}
        </div>
      </CSSTransition>
    );
  });

  return {
    items: readyItems,
    conteinerHeight,
  };
}
